/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import Navbar from './components/Navbar';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';
import Header from './components/Header';
import Footer from './components/Footer';
import About from './components/About';
import Experience from './components/Experience';

const App = () => (
  <div className="app_container container">
    <Header />
    <Navbar />
    <About />
    <Portfolio />
    <Experience />
    <Contact />
    <Footer />
  </div>
);

export default App;
